import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { DataService } from '../data/data.service';
interface MainMenu {
  menu: MenuItem[];
}

interface MenuItem {
  menuValue: string;
  showSubRoute: boolean;  
}
@Injectable({
  providedIn: 'root',
})
export class SideBarService {
  public toggleSideBar: BehaviorSubject<string> = new BehaviorSubject<string>(
    localStorage.getItem('isMiniSidebar') || "false"
  );

  public toggleMobileSideBar: BehaviorSubject<string> = new BehaviorSubject<string>(
    'false'
  );

  public expandSideBar: BehaviorSubject<string> = new BehaviorSubject<string>("false");

  constructor(private data: DataService, @Inject(DOCUMENT) private document: Document) {
    this.closeMobileSideBar();
  }

  public switchSideMenuPosition(): void {
    if (localStorage.getItem('isMiniSidebar')) {
      this.toggleSideBar.next("false");
      localStorage.removeItem('isMiniSidebar');
      this.data.sideBar.map((mainMenus: MainMenu) => {
        mainMenus.menu.map((resMenu: MenuItem) => {
          const menuValue = sessionStorage.getItem('menuValue');
          if (menuValue && menuValue == resMenu.menuValue) {
            resMenu.showSubRoute = true;
          }
        });
      });
    } else {
      this.toggleSideBar.next('true');
      localStorage.setItem('isMiniSidebar', 'true');
      this.data.sideBar.map((mainMenus: MainMenu) => {
        mainMenus.menu.map((resMenu: MenuItem) => {
          resMenu.showSubRoute = false;
        });
      });
    }
  }

  public switchMobileSideBarPosition(): void {
    if (this.toggleMobileSideBar.value === 'true') {
      this.closeMobileSideBar();
    } else {
      this.document.documentElement.classList.add('menu-opened');
      this.toggleMobileSideBar.next('true');
    }
  }

  public closeMobileSideBar(): void {
    this.document.documentElement.classList.remove('menu-opened');
    this.document.body.classList.remove('slide-nav', 'opened');
    this.document.getElementById('sidebar')?.classList.remove('opened');
    this.toggleMobileSideBar.next('false');
    localStorage.removeItem('isMobileSidebar');
  }

}
